import React, { useEffect, useState } from "react";
import { closeModal, SweetAlertShow } from "../../master/Master";
import { getBatchList } from "../../../api/BatchService";
import { enquiryStatusChange } from "../../../api/Enquiry";
import { useNavigate } from "react-router-dom";

export default function StatusModal({
  data,
  setData,
  setLoading,
  handleFunction,
}) {
  const [batches, setBatches] = useState([]);
  const navigate = useNavigate();

  const getBatches = async () => {
    setLoading(true);
    try {
      const response = await getBatchList();
      if (response.data.status) {
        setBatches(response?.data?.data);
      } else {
        SweetAlertShow("info", "warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.response?.message
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getBatches();
  }, []);

  const handleForm = async (e) => {
    e.preventDefault();
    if (Number(e.target.status.value) === 1) {
      closeModal("StatusChange");
      navigate(`/student/add?enquiry_id=${data?.id}`);
      e?.target?.reset();
      return "";
    }
    setLoading(true);
    try {
      const formData = new FormData(e.target);
      const response = await enquiryStatusChange(formData);
      if (response?.data?.status) {
        closeModal("StatusChange");
        e?.target?.reset();
        SweetAlertShow("success", "Successfully", response?.data?.message);
      } else {
        SweetAlertShow("info", "warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
        error?.response?.message ??
        error?.message
      );
    } finally {
      setLoading(false);
      handleFunction();
    }
  };
  return (
    <>
      <div
        className="modal fade"
        id="StatusChange"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <form action="" onSubmit={handleForm}>
              <div className="modal-header py-3 bg-label-primary">
                <h1 className="modal-title fs-5" id="exampleModalLabel">
                  Change Status
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />
              </div>
              <div className="modal-body">
                <div className="row g-5">
                  <input type="hidden" name="id" value={data?.id} />
                  <div className="col-12">
                    <div className="form-floating form-floating-outline">
                      <select
                        className="form-select form-control"
                        name="status"
                        id="status"
                        value={data?.status}
                        onChange={(e) =>
                          setData({ ...data, status: e.target.value })
                        }
                        required
                      >
                        <option value="0">Pending</option>
                        <option value="1">Admitted</option>
                        <option value="2">Not Interested</option>
                        <option value="4">Demo Classes</option>
                        <option value="5">Visit</option>
                      </select>
                      <label className="">Select Status</label>
                    </div>
                  </div>
                  {Number(data?.status) === 4 && (
                    <>
                      <div className="col-12">
                        <div className="form-floating form-floating-outline">
                          <select
                            className="form-select form-control"
                            name="batch_id"
                            id="batch_id"
                            value={data?.batch_id}
                            onChange={(e) =>
                              setData({ ...data, batch_id: e.target.value })
                            }
                            required
                          >
                            <option value="" selected disabled>
                              Select Batch
                            </option>
                            {batches?.map((batch, i) => (
                              <option value={batch?.id}>
                                {batch?.title} ({batch?.course?.title})
                              </option>
                            ))}
                          </select>
                          <label className="">Select Batch</label>
                        </div>
                      </div>

                      <div className="col-12">
                        <div className="form-floating form-floating-outline">
                          <input
                            className="form-control"
                            name="demo_days"
                            placeholder="Demo Days"
                            value={data?.demo_days ?? 3}
                            onChange={(e) =>
                              setData({ ...data, demo_days: e.target.value })
                            }
                          />
                          <label>Demo Days</label>
                        </div>
                      </div>
                    </>
                  )}
                  <div className="col-12">
                    <div className="form-floating form-floating-outline">
                      <textarea
                        className="form-control input-uppercase"
                        name="note"
                        placeholder="Note"
                        value={data?.note}
                        onChange={(e) =>
                          setData({ ...data, note: e.target.value })
                        }
                      />
                      <label>Note</label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer py-3 bg-label-primary">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button type="submit" className="btn btn-primary">
                  Save changes
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
